import "./CSS/DashboardScreen.css";
import cardFirstImage from "../../assets/images/dashboard-member-benefits-card-first.png";
import cardSecondImage from "../../assets/images/dashboard-member-benefits-card-second.png";
import headerAppIcon from "../../assets/images/dashboard-header-app-icon.svg";
import headerConnectIcon from "../../assets/images/dashboard-header-connect-icon.svg";
import headerRSVPLocationIcon from "../../assets/images/dashboard-rsvp-location-icon.svg";
import { useEffect, useState } from "react";
import DashboardScreenDetailFooter from "./Views/DashboardScreenDetailFooter";
import { useQuery } from "@tanstack/react-query";
import useWSMApi from "services/api/useWSMApi";
import { CALENDAR_RESERVATION_TYPE, MENU_ITEM } from "utils/constants";
import { useTabBar } from "services/TabBarProvider";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";

interface Benefits {
  title: string;
  buttonTitle: string;
  image: string;
}

const DashboardScreen = () => {
  const memberBenefits: Benefits[] = [
    {
      title: "Deep Focus WorkSpace",
      buttonTitle: "Explore",
      image: cardFirstImage,
    },
    {
      title: "Mind Body Studio",
      buttonTitle: "Explore",
      image: cardSecondImage,
    },
    {
      title: "Events & Retreats",
      buttonTitle: "Explore",
      image: cardFirstImage,
    },
    {
      title: "Scaling Workshops",
      buttonTitle: "Explore",
      image: cardSecondImage,
    },
    {
      title: "Meeting Rooms",
      buttonTitle: "Explore",
      image: cardFirstImage,
    },
  ];

  const [userProfileData, setUserProfileData] = useState<any>(null);
  const navigate = useNavigate();
  const { setSelectedTabBar } = useTabBar();
  const { fetchExclusiveSlot } = useWSMApi();

  const { data: exclusiveSoltData, error: exclusiveSlotError } = useQuery({
    queryKey: ["fetch-exclusive-slot"],
    queryFn: () => fetchExclusiveSlot(),
    retry: false,
  });

  useEffect(() => {
    const storedData = localStorage.getItem("userProfileData");
    if (storedData) {
      const userData = JSON.parse(storedData);
      setUserProfileData(userData);
    }
  }, []);

  const handleMemberBenefitsChange = (index: number) => {
    const tabType =
      index === 0
        ? CALENDAR_RESERVATION_TYPE.DF_WORKSPACE
        : index === 1
        ? CALENDAR_RESERVATION_TYPE.MB_STUDIO
        : index === 2
        ? CALENDAR_RESERVATION_TYPE.EVENTS
        : index === 3
        ? CALENDAR_RESERVATION_TYPE.WORKSHOP
        : CALENDAR_RESERVATION_TYPE.MEETING_ROOMS;
    sessionStorage.setItem("calendarSelectedTab", tabType);
    setSelectedTabBar(MENU_ITEM.CALENDAR);
  };

  const handleViewClick = () => {
    if (exclusiveSoltData) {
      localStorage.setItem(
        "selectedSlotData",
        JSON.stringify(exclusiveSoltData)
      );
      navigate(ROUTE_PATHS.WSM_RESERVATIONS);
    }
  };

  return (
    <div className="wms-mobile-container">
      <div className="dashboard-screen-main-container">
        <div className="dashboard-screen-header-bar">
          <img src={headerAppIcon} alt="left-button" />
          <div className="right-container">
            <img src={headerConnectIcon} alt="left-button" />
            <span>Connect</span>
          </div>
        </div>
        <div className="dashboard-screen-header-container">
          <div className="title">Welcome</div>
          <div className="sub-title">{`${userProfileData?.first_name}`}</div>
        </div>

        {!exclusiveSlotError && (
          <div className="dashboard-screen-detail-container">
            <div className="header-title">coming up</div>
            <div
              className="image-container"
              style={{
                backgroundImage: `url(${exclusiveSoltData?.slot_image})`,
              }}
            >
              <div className="header-container">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span className="primary">
                    {(() => {
                      if (!exclusiveSoltData?.title) return null;
                      const words = exclusiveSoltData.title.split(" ");
                      const lastWord = words.pop();
                      const rest = words.join(" ");
                      return (
                        <>
                          {rest}{" "}
                          <span style={{ color: "#FF6B35" }}>{lastWord}</span>
                        </>
                      );
                    })()}
                  </span>
                </div>
                <div className="location-title">
                  <img src={headerRSVPLocationIcon} alt="location-icon" />
                  {exclusiveSoltData?.location}
                </div>
              </div>
              <div className="dashboard-screen-spots-container">
                <div className="content">
                  <span className="primary">
                    {Number(exclusiveSoltData?.total_seats || 0) -
                      Number(exclusiveSoltData?.reserved_seats || 0)}
                  </span>
                  <span className="secondary">Spots</span>
                </div>
              </div>
              <DashboardScreenDetailFooter
                slotDate={exclusiveSoltData?.slot_date}
                slotTime={exclusiveSoltData?.start_time}
                onClickView={handleViewClick}
              />
            </div>
          </div>
        )}

        <div className="dashboard-screen-member-benefits-container">
          <div className="header-title">Member Benefits</div>
          <div className="dashboard-screen-member-benefits-list-container">
            {memberBenefits.map((benefits, index) => (
              <div key={index}>
                <div className="divider"></div>
                <div
                  key={index}
                  className="dashboard-screen-member-benefits-list-item"
                  style={{
                    backgroundImage: `url(${benefits.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                  onClick={() => handleMemberBenefitsChange(index)}
                >
                  <div
                    className={`dashboard-screen-member-benefits-list-sub-item ${
                      index % 2 === 0 ? "odd-card" : "even-card"
                    }`}
                  >
                    <div className="title">{benefits.title}</div>
                    <div className="btn-container">
                      <button>{benefits.buttonTitle}</button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardScreen;
